import { Table } from "antd";
import React from "react";
import { skladKomplekt } from "../Form/formData";
import { newData } from "../Form/TableData";
import AddModal from "../Modal/index";

function SkladKomplekt() {
  const columns = [
    {
      title: "#",
      dataIndex: "key",
    },
    {
      title: "Dokument",
      dataIndex: "dokument",
    },
    {
      title: "Data",
      dataIndex: "data",
    },
    {
      title: "Postavshik",
      dataIndex: "postavshik",
    },
    {
      title: "Sklad",
      dataIndex: "sklad",
    },
    {
      title: "Kommentarii",
      dataIndex: "sklad",
    },
    {
      title: "Vsego",
      dataIndex: "vsego",
    },
  ];

  return (
    <>
      <AddModal
        title={"Поступ.комплект"}
        stil={"stil"}
        width={850}
        form={skladKomplekt}
        columnsAll={skladKomplekt[0].columns}
        table={newData}
        button={true}
      />
      <div className="mt-2">
        <Table columns={columns} />
      </div>
    </>
  );
}

export default SkladKomplekt;
